import React, { createContext, useContext, useEffect, useState } from 'react';
import { fetchProgressionState, advanceProgressionStage } from '../api';
import { AuthContext } from './AuthContext';

const ProgressionContext = createContext(null);

export function ProgressionProvider({ children }) {
  const { user } = useContext(AuthContext);
  const [progressionState, setProgressionState] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;

    async function loadState() {
      if (!user) {
        setProgressionState(null);
        setLoading(false);
        return;
      }
      try {
        const res = await fetchProgressionState();
        if (alive) {
          setProgressionState(res.data.progression);
          setLoading(false);
        }
      } catch (err) {
        console.error('Error fetching progression state:', err);
        if (alive) {
          setLoading(false);
        }
      }
    }

    loadState();
    return () => { alive = false; };
  }, [user]);

  const refreshState = async () => {
    if (!user) return;
    try {
      const res = await fetchProgressionState();
      setProgressionState(res.data.progression);
    } catch (err) {
      console.error('Error refreshing progression state:', err);
    }
  };

  const advanceStage = async (nextStage) => {
    try {
      const res = await advanceProgressionStage(nextStage);
      setProgressionState(res.data.progression);
      return res.data.progression;
    } catch (err) {
      console.error('Error advancing progression stage:', err);
      throw err;
    }
  };

  const value = {
    progressionState,
    loading,
    advanceStage,
    refreshState
  };

  return (
    <ProgressionContext.Provider value={value}>
      {children}
    </ProgressionContext.Provider>
  );
}

export function useProgression() {
  return useContext(ProgressionContext);
}

export default ProgressionContext;
